// BEFORE AFTER SLIDER - Original from fn-2024.js
// Wrapped to ensure jQuery is loaded

(function() {
  'use strict';
  
  // Wait for jQuery to be available
  function initSlider() {
    if (typeof jQuery === 'undefined') {
      setTimeout(initSlider, 50);
      return;
    }

    jQuery(function($) {

      if($('#ba-slider').length) {

        var pxWidth =  $('.ba-cont').outerWidth();
        $('.ba-image').each(function(index) {
          $(this).css('width', pxWidth+'px');
        });

        $(window).bind('resize', function(){
          $('.ba-image').removeAttr('style');
          var pxWidth =  $('.ba-cont').outerWidth();
          $('.ba-image').each(function(index) {
            $(this).css('width', pxWidth+'px');
          });
        });




        $('.ba-slider-wrap').each(function(){

          var ht;

          window.setTimeout(function () {
            var elementHeights = $('.ba-text .inner').map(function() {
              return $(this).outerHeight();
            }).get();
            var ht = Math.max.apply(null, elementHeights);
            $('.ba-text').height(ht);
            $('.ba-image').css('padding-bottom', ht+'px');
          }, 10);

          $(window).bind('resize', function(){
            window.setTimeout(function () {
              var elementHeights = $('.ba-text .inner').map(function() {
                return $(this).outerHeight();
              }).get();
              var ht = Math.max.apply(null, elementHeights);
              $('.ba-text').height(ht);
              $('.ba-image').css('padding-bottom', ht+'px');
            }, 10);
          });

        });



        $('.ba-cont').each(function(){

          var ht;

          window.setTimeout(function () {
            var elementHeights = $('.ba-image').map(function() {
              return $(this).outerHeight();
            }).get();
            var ht = Math.max.apply(null, elementHeights);
            $('.ba-cont').height(ht);
          }, 100);

          $(window).bind('resize', function(){
            window.setTimeout(function () {
              var elementHeights = $('.ba-image').map(function() {
                return $(this).outerHeight();
              }).get();
              var ht = Math.max.apply(null, elementHeights);
              $('.ba-cont').height(ht);

            }, 100);
          });

        });


        if($(window).width() >= 990) {
          $("#ba-slider").attr('value', 50);
          $('.ba-img.ba-foreground-img').css('width', '50%');
          $('.ba-slider-button').css('left', `calc(50% - 28px)`);
        } else if($(window).width() >= 750) {
          $("#ba-slider").attr('value', 20);
          $('.ba-img.ba-foreground-img').css('width', '20%');
          $('.ba-slider-button').css('left', `calc(20% - 28px)`);
        } else {
          $("#ba-slider").attr('value', 5);
          $('.ba-img.ba-foreground-img').css('width', '5%');
          $('.ba-slider-button').css('left', `calc(5% - 22px)`);
        }

        $(window).bind('resize', function(){
          if($(window).width() >= 990) {
            $("#ba-slider").attr('value', 50);
            $('.ba-img.ba-foreground-img').css('width', '50%');
            $('.ba-slider-button').css('left', `calc(50% - 28px)`);
          } else if($(window).width() >= 750) {
            $("#ba-slider").attr('value', 20);
            $('.ba-img.ba-foreground-img').css('width', '20%');
            $('.ba-slider-button').css('left', `calc(20% - 28px)`);
          } else {
            $("#ba-slider").attr('value', 5);
            $('.ba-img.ba-foreground-img').css('width', '5%');
            $('.ba-slider-button').css('left', `calc(5% - 22px)`);
          }
        });



        $("#ba-slider").on("input change", (e)=>{
          var sliderPos = e.target.value;
          // sliderPos = sliderPos - 1;
          // Update the width of the foreground image
          $('.ba-foreground-img').css('width', `${sliderPos}%`)
          // Update the position of the slider button
          if($(window).width() >= 750) {
            $('.ba-slider-button').css('left', `calc(${sliderPos}% - 28px)`);
          } else {
            $('.ba-slider-button').css('left', `calc(${sliderPos}% - 22px)`);
          }

        });


      }

    });
  }
  
  initSlider();
  
})();